const ChocolateBrownSpinner = () => {
    return (
      <div
        className="w-12 h-12 border-4 border-chocolateBrown border-t-transparent rounded-full animate-spin"
        style={{ borderColor: '#7B3F00', borderTopColor: 'transparent' }}
        aria-label="loading"
        role="status"
      />
    );
  };
  
  export default ChocolateBrownSpinner;
  